'use client';
import React from 'react';

const ProgressUpdate = () => {
  return (
    <section id="progress" className="py-12 bg-[#fff]">
      <div className="mx-4 mt-4 mb-6">
        <div className="container mx-auto max-w-8xl">
          <div className="max-w-8xl mx-auto text-base md:text-lg text-[#005e60]">
            <hr style={{ borderColor: '#CDE4E4', borderWidth: '1px', marginBottom:'25px' }} />
            <h2 className="text-4xl md:text-5xl font-extrabold mb-8 text-[#005e60]">
              PROGRESS UPDATE
            </h2>
            
            <h3 className="text-2xl md:text-3xl font-bold mb-6 text-[#005e60]">
              What’s Next
            </h3>
            
            <p className="leading-relaxed mb-5">
            With greater clarity about the site’s heritage status, GE Vernova can continue to move forward with the work required to deconstruct the remaining vacant buildings on the site. As a first step, GE Vernova is selecting qualified Project and Construction Managers to help plan, coordinate, and oversee the work.
            </p>

                        <p className="leading-relaxed mb-5">
            Bringing together the right team, early on, is important. This team will help develop the environmental, health and safety-related plans, as well as the materials needed to apply for a demolition permit. 
            </p>

                        <p className="leading-relaxed mb-5">
           Deconstructing older buildings is complex, and the work will be planned in a way that balances this with protecting the environment, workers, and surrounding community. This planning will take time. Before any demolition permit applications are submitted to the Chief Building Official, GE Vernova will seek review and input from the Ministry of the Environment, Conservation and Parks on its draft plans.
            </p>

                        <p className="leading-relaxed mb-5">
           GE Vernova will continue working with all relevant authorities as the deconstruction phase of the project moves forward, and remains committed to keeping the community informed.
            </p>

            <h3 className="text-2xl md:text-3xl font-bold mb-6 mt-10 text-[#005e60]">
              Current Maintenance Activities
            </h3>
            
            <p className="leading-relaxed mb-5">
            Separately, GE Vernova is conducting scheduled and necessary maintenance on Building 30, which involves roof repairs and replacement. This is one of the four buildings identified by the City as having architectural heritage value and which is being retained by GE Vernova. This maintenance work is anticipated to be completed in 2026. 
            </p>
          
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgressUpdate;
